module.exports = __webpack_public_path__ + "img/user.2e0a1b45.svg";